module.exports = __webpack_public_path__ + "static/media/12_NL.6625f1d9.mp3";